import { CopyToClipboard } from "../Copy";
import Tooltip from "../Tooltip/Tooltip";
import Icon from "../Icon/Icon";
import { Validity } from "utils/enums/validity";

interface CardItem {
  prefix: string;
  value?: string | null;
  isBadge?: boolean;
  isCopy?: boolean;
  defaultGreen?: boolean;
  borderBottom?: boolean;
  isLink?: boolean;
  validity?: Validity;
  showIcon?: boolean;
}
interface CardItemPropsWithLink {
  isLink?: true;
  link: string;
}
interface CardItemPropsWithoutLink {
  isLink?: false;
}

type CardItemProps = CardItem &
  (CardItemPropsWithLink | CardItemPropsWithoutLink);
export const CardItem: React.FC<CardItemProps> = (props) => {
  const selectColor = {
    1: "Likely",
    2: "Likely",
    3: "Verified",
    4: "Likely",
    5: "Likely",
  };
  return (
    <div
      className={`flex flex-row justify-between w-full items-center py-2 h-fit gap-1 md:gap-0 md:h-12 ${
        props.borderBottom && "border-b border-gray-700"
      }`}
    >
      <small className="text-sm text-white-500 truncate w-fit">
        {props.prefix}
      </small>
      <div className="flex items-center gap-3 w-fit">
        {props.value ? (
          <h4
            className={`text-sm truncate md:px-2 md:w-fit w-full  ${
              props.isBadge &&
              `badge p-1 font-bold ${selectColor[props.validity || 1]} ${
                props.defaultGreen && "green"
              }`
            }`}
          >
            {props.isLink ? (
              <a
                target="_blank"
                className="link"
                href={props.link}
                rel="noreferrer"
              >
                {props.value}
              </a>
            ) : (
              props.value || "-"
            )}
            {/* {props.validity === 3 ? props.showIcon && <Tooltip content={selectColor[props.validity || 1] || ''}><Icon className="md:block" name="check-circle" size={14} /></Tooltip> : ''}
                        {props.validity !== 3 ? props.showIcon && <Tooltip content={selectColor[props.validity || 1] || ''}><Icon className="md:block" name="bulb" size={14} /></Tooltip> : ''} */}
            {props.isCopy && props.value && (
              <CopyToClipboard text={props.value || "-"} />
            )}
          </h4>
        ) : (
          <h4>-</h4>
        )}
      </div>
    </div>
  );
};
